export const recentSearches = [
  "Address: 123 Jalan Legian, Kuta",
  "123 Jalan Legian, Kuta",
];
